// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"099820b4","533":"deba218e","669":"099820b4"}[chunkId] + ".chunk.css";
};